import React, { useEffect, useState } from "react";
import { UtensilsCrossed } from "lucide-react";
import api from "@/lib/api";

export default function DayMenuHint({ date, meal }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/menus/for-day", { params: { date } }).then((r) => setRows(r.data)).catch(() => setRows([])); }, [date]);
  const items = rows.filter((r) => r.meals?.[meal]);
  if (items.length === 0) return null;
  return (
    <div className="rounded-xl border border-primary/30 bg-primary/5 px-4 py-3 space-y-1.5" data-testid="day-menu-hint">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary"><UtensilsCrossed className="h-3.5 w-3.5" /> Günün Menüsü · {meal}</div>
      {items.map((r) => (
        <div key={r.menu_id} className="text-sm" data-testid={`day-menu-${r.menu_id}`}>
          <span className="font-medium">{r.name}</span>
          {r.customers.length > 0 && <span className="text-xs text-muted-foreground"> ({r.customers.map((c) => c.name).join(", ")})</span>}
          <span className="text-muted-foreground">: </span>{r.meals[meal]}
        </div>
      ))}
    </div>
  );
}
